<app-header></app-header>
<main class="background-bar mb-2 mb-md-8h">
  <div class="container">
    <div class="row justify-content-center">
      <div [class.col-md-9]="isResumeRoute"
           [class.col-md-8]="!isResumeRoute">
        <router-outlet></router-outlet>
      </div>
      <div class="col-md-4"
           *ngIf="!isResumeRoute">
        <app-plan-resume></app-plan-resume>
      </div>
    </div>
  </div>
</main>
<div #loaderContainer class="loader-container">
  <div class="loader"></div>
</div>
<app-toast></app-toast>
<app-footer></app-footer>
